import { Link } from 'react-router-dom';
import { Film, Mail, MapPin, Youtube, Instagram, Facebook } from 'lucide-react';

const LOGO_URL = "https://res.cloudinary.com/drcoefnzk/image/upload/v1771512904/456542092_122097483962499699_7816098867247799670_n_d0jy4p.jpg";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer data-testid="footer" className="bg-[#0a0a0a] border-t border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-6">
              <img 
                src={LOGO_URL} 
                alt="Swarnali Entertainment" 
                className="h-14 w-14 rounded-full object-cover border-2 border-[#D4AF37]"
              />
              <div>
                <span className="font-heading text-xl tracking-wider text-white block">SWARNALI</span>
                <span className="text-xs tracking-[0.3em] text-[#D4AF37] uppercase">Entertainment</span>
              </div>
            </div>
            <p className="text-[#A3A3A3] text-sm leading-relaxed">
              Crafting compelling stories through the lens of Hindi cinema. Producer Swarnali Acharya brings visions to life.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg tracking-wider text-white mb-6 uppercase">Quick Links</h4>
            <ul className="space-y-3">
              {['Home', 'Films', 'About Us', 'Auditions', 'Contact'].map((item) => (
                <li key={item}>
                  <Link
                    to={item === 'Home' ? '/' : `/${item.toLowerCase().replace(' ', '-').replace('-us', '')}`}
                    className="text-[#A3A3A3] hover:text-white transition-colors text-sm"
                  >
                    {item}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Our Films */}
          <div>
            <h4 className="font-heading text-lg tracking-wider text-white mb-6 uppercase">Our Films</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/films" className="text-[#A3A3A3] hover:text-[#E50914] transition-colors text-sm flex items-center gap-2">
                  <Film size={14} />
                  Aprokashito (2024)
                </Link>
              </li>
              <li>
                <span className="text-[#D4AF37] text-sm flex items-center gap-2">
                  <Film size={14} />
                  Hindi Film (Coming 2026)
                </span>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg tracking-wider text-white mb-6 uppercase">Contact Us</h4>
            <ul className="space-y-4">
              <li className="flex items-start gap-3 text-[#A3A3A3] text-sm">
                <MapPin size={16} className="text-[#D4AF37] mt-1 flex-shrink-0" />
                <span>Kolkata, West Bengal, India</span>
              </li>
              <li className="flex items-center gap-3 text-[#A3A3A3] text-sm">
                <Mail size={16} className="text-[#D4AF37] flex-shrink-0" />
                <a href="mailto:swarnalientertainment.social@gmail.com" className="hover:text-white transition-colors break-all">
                  swarnalientertainment.social@gmail.com
                </a>
              </li>
            </ul>

            {/* Social Links */}
            <div className="flex items-center gap-4 mt-6">
              <a
                href="https://www.youtube.com/@SwarnaliEntertainment/featured"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-[#A3A3A3] hover:bg-[#E50914] hover:text-white transition-all"
                data-testid="footer-youtube"
              >
                <Youtube size={18} />
              </a>
              <a
                href="https://www.instagram.com/swarnalientertainment"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-[#A3A3A3] hover:bg-[#E50914] hover:text-white transition-all"
                data-testid="footer-instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://www.facebook.com/swarnalientertainment"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white/5 flex items-center justify-center text-[#A3A3A3] hover:bg-[#E50914] hover:text-white transition-all"
                data-testid="footer-facebook"
              >
                <Facebook size={18} />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-12 pt-8 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-[#A3A3A3] text-sm">
            © {currentYear} Swarnali Entertainment. All rights reserved | Designed by <a href="https://cubemultimedia.in/" target="_blank" rel="noopener noreferrer" className="text-[#D4AF37] hover:text-white transition-colors">Cube Multimedia</a>
          </p>
          <p className="text-[#A3A3A3] text-sm font-accent italic">
            "Stories that resonate, cinema that inspires"
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
